import PropTypes from 'prop-types';
import { Component, Children } from 'react';
import withSideEffect from 'react-side-effect';
import _ from 'lodash';

import InAppStore from '../../stores/InAppStore';
import InAppActions from '../../actions/InAppActions';

function handleStateChangeOnClient(state) {
    // the state is null when every <AppNotify> unmounted before the debounce fired
    if (!state || !InAppStore.isInApp()) { return; }

    const { title, goBack } = state;
    InAppActions.notifyNavbar(title, goBack);
}

class AppNotify extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        goBack: PropTypes.bool,
        children: PropTypes.any
    };

    render () {
        return Children.only(this.props.children);
    }
}


function reducePropsToState(propsList) {
    var innermostProps = propsList[propsList.length - 1];
    if (innermostProps) {
        return innermostProps;
    }
    return null;
}

export const appNotifyFactory = (debounce = _.debounce) => withSideEffect(reducePropsToState, debounce(handleStateChangeOnClient))(AppNotify);

export default appNotifyFactory();
